import useRepo from '@/nebula/repo';
import { appFeedback as appFeedbackConfig } from 'shared/api/query/configs.json';

export default function useAppFeedbackRepo() {
  return useRepo(appFeedbackConfig.model);
}
